import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateMultiline } from 'foundations-components/transitional/components/TruncateMultiline';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const FragmentWrapper = ({
  children
}) => /*#__PURE__*/_jsx(_Fragment, {
  children: children
});
const TruncateInlineString = ({
  text,
  maxChars = 20,
  placement = 'bottom'
}) => {
  const shouldTruncate = text.length > maxChars;
  if (!shouldTruncate) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: text
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: text,
    zIndex: 1500,
    placement: placement,
    children: /*#__PURE__*/_jsx(TruncateMultiline, {
      cursor: "help",
      text: text,
      maxChars: maxChars,
      Paragraph: FragmentWrapper
    })
  });
};
export default TruncateInlineString;